<template>
  <div>
    <el-dialog title="用户信息修改" :visible.sync="visible" width="500px" :before-close="closeDialog" @open="loadUser">
      <el-form v-if="user" ref="form" :model="user" :rules="rules" style="width:400px" label-width="100px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="user.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="user.name"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="me?(me.id===userId):false">
          <el-input v-model="user.password" type="password"></el-input>
        </el-form-item>
        <el-form-item align="center">
          <el-button @click="$refs.form.resetFields()">重 置</el-button>
          <el-button @click="submit" type="primary">提 交</el-button>
          <el-button @click="resetPassword" type="danger">重置密码</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { rules } from "@/utils";

export default {
  props: {
    userId: Number,
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(["me"])
  },
  data() {
    return {
      user: null,
      rules: {
        username: [
          rules.required(),
          {
            validator: async (r, v) => {
              if (v === this.user.originUsername) {
                return;
              }
              let res = await this.$request(
                this.$api.user.exist({ username: v })
              );
              if (res) {
                throw new Error("用户名已存在");
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    ...mapActions("user", ["update"]),
    async loadUser(){
      if (!this.userId){
        this.closeDialog();
        this.$message.error("缺少用户ID");
      }else{
        let user = await Vue.store.dispatch("user/get", {id: this.userId});
        this.user = {
          ...user,
          originUsername: user.username
        };
      }
    },
    async submit() {
      let ok = await this.$refs.form.validate();
      if (!ok) {
        return;
      }
      let res = await this.update(this.user);
      this.user.originUsername = res.username;
      this.$message.success("更新成功");
      this.closeDialog();
    },
    async resetPassword() {
      this.$confirm(`重置${this.user.username}的密码为 123456 ？`)
        .then(() => {
          this.user.password = "123456";
          return this.update(this.user);
        })
        .then(res => {
          this.$message.success("密码已重置");
        });
    },
    closeDialog(){
      this.$emit('update:visible', false);
      this.user = null;
    }
  }
};
</script>
